import React, { useState, useEffect } from 'react'
import { Button } from "../../ui/button"
import { X, Play } from 'lucide-react'

export function DemoWalkthroughBar() {
  const [isVisible, setIsVisible] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    const isDismissed = localStorage.getItem('demo-walkthrough-dismissed')
    if (!isDismissed) {
      const timer = setTimeout(() => {
        setIsVisible(true)
        setIsAnimating(true)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleDismiss = () => {
    setIsAnimating(false)
    setTimeout(() => {
      setIsVisible(false)
      localStorage.setItem('demo-walkthrough-dismissed', 'true')
    }, 200)
  }

  const handleWatchDemo = () => {
    console.log('Opening demo walkthrough...')
  }

  if (!isVisible) return null

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ease-out hidden ${
        isAnimating ? 'transform translate-y-0 opacity-100' : 'transform translate-y-full opacity-0'
      }`}
    >
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm border-t border-border/50"></div>
      <div className="relative container mx-auto max-w-[1200px] px-10 md:px-[72px] py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3">
              <div className="text-base font-medium text-foreground">
                New here? 👉 See how to log in & get started with AIRA.
              </div>
            </div>
            <div className="text-sm text-muted-foreground mt-1">
              1-min demo walkthrough — your shortcut to first win.
            </div>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Button
              onClick={handleWatchDemo}
              className="h-10 px-6 rounded-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white hover:scale-[1.02] transition-all duration-200 flex items-center gap-2 relative group/demo"
            >
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 opacity-0 group-hover/demo:opacity-20 transition-opacity duration-200 blur-lg -z-10"></div>
              <Play className="h-4 w-4" />
              Watch Demo
            </Button>
            <Button onClick={handleDismiss} variant="ghost" size="sm" className="w-8 h-8 p-0 hover:bg-accent/50 transition-colors duration-200">
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}


